<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-class="redmfu">
                <div slot="header">
                  <strong>
                    สถิติแยกตาม
                    <u>ประเภท</u>(ต่างชาติ)
                  </strong>
                </div>
<!--                <b-row>-->
<!--                  <b-col lg="3"></b-col>-->
<!--                  <b-col lg="6">-->
<!--                    <b-table striped hover :items="items" :fields="fields"></b-table>-->
<!--                  </b-col>-->
<!--                  <b-col lg="3"></b-col>-->
<!--                </b-row>-->
                <br><br>
                <b-row>
                  <b-col lg="3"></b-col>
                  <b-col lg="6">
                    <b-table striped hover :items="items_2" :fields="fields_2"></b-table>
                  </b-col>
                  <b-col lg="3"></b-col>
                </b-row>

                <b-row>
                  <b-col lg="3"></b-col>
                  <b-col lg="6">
                    <!-- <b-table striped hover >
                      <b-row>
                        <b-col>sadfasdf
                        </b-col>
                      </b-row>
                    </b-table> -->
                    <br><br><strong> สรุปการลงทะเบียนแจ้งการเข้ารับปริญา<font color="red"><u>เฉพาะต่างชาติ</u></font></strong><br><br>
                    <table  border="0" width=100% >
                      <tr bgcolor="#f8f9fa  " height="40">
                        <td>&nbsp&nbsp&nbspเข้ารับพระราชทานปริญญาบัตร
                        </td>
                        <td><div align=right><a :href="'#/Reportattend?thai=0'">{{ total_yes.toLocaleString()}}</a>&nbsp&nbsp&nbsp</div>
                        </td>
                      </tr>
                      <tr bgcolor="#e9ecef" height="40">
                        <td>&nbsp&nbsp&nbsp<u>ไม่</u>เข้ารับพระราชทานปริญญาบัตร
                        </td>
                        <td><div align=right><a :href="'#/Reportnotattend?thai=0'">{{ total_no.toLocaleString()}}</a>&nbsp&nbsp&nbsp</div>
                        </td>
                      </tr>
                      <tr bgcolor="#dee2e6" height="40">
                        <td>&nbsp&nbsp&nbspบันทึก<u>ไม่</u>สมบูรณ์
                        </td>
                        <td><div align=right><a :href="'#/Reportincompleted?year=2565&level=10&thai=0'">
                          {{ (total_all-(total_yes+total_no)).toLocaleString() }}
<!--                          {{ total_notcomplete.toLocaleString()}}-->
                        </a>&nbsp&nbsp&nbsp</div>
                        </td>
                      </tr>
                      <tr bgcolor="#ced4da" height="40">
                        <td>&nbsp&nbsp&nbspรวมผู้ลงทะเบียนทั้งมด
                        </td>
                        <td><div align=right>{{ total_all.toLocaleString()}}&nbsp&nbsp&nbsp</div>
                        </td>
                      </tr>
                      <tr bgcolor="#adb5bd" height="40">
                        <td><font color=red>&nbsp&nbsp&nbspรวมผู้ที่ยัง<u>ไม่ได้</u>บันทึกลงทะเบียนแจ้งการเข้ารับปริญญา</font>
                        </td>
                        <td><div align=right><font color=red><a :href="'#/Reportnotregis?year=2565&level=10&id=0&thai=0'">{{ (total2- total_all).toLocaleString()}}</a>&nbsp&nbsp&nbsp</font></div>
                        </td>
                      </tr>
                      <tr bgcolor="#6c757d" height="40">
                        <td><font color=white>&nbsp&nbsp&nbspรวมผู้มีสิทธิ์เข้ารับปริญาบัตรทั้งหมด</font>
                        </td>
                        <td> <div align=right><font color=white>{{ total2.toLocaleString() }}</font></div>
                        </td>
                      </tr>
                    </table>

                  </b-col>
                  <b-col lg="3"></b-col>
                </b-row>
                <!-- <div v-for="item in items" v-bind:key="item.DATETOTAL">
                  <b-row>
                    <b-col>{{i+1}}</b-col>
                    <b-col>{{item.GRADUATE_STATUS_NAME}}</b-col>
                    <b-col>{{item.TOTAL}}</b-col>
                  </b-row>
                </div>-->
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: { YimoVueEditor },
  name: "CreateReporttypeforeignrs",
  data() {
    return {
      fields: [
        {
          key: "GRADUATE_STATUS_NAME",
          label: "สถานะ",
          formatter: "GRADUATE_STATUS_NAME"
        },
        {
          key: "TOTAL",
          label: "จำนวน",
          formatter: "TOTAL"
        }
      ], fields_2: [
        {
          key: "COUNTRYNAME",
          label: "ประเทศ",
          formatter: "COUNTRYNAME"
        },
        {
          key: "TOTAL",
          label: "จำนวน",
          formatter: "TOTAL"
        }
      ],
       fields_3: [
        {
          key: "TOPIC",
          label: "ประเทศ",
          formatter: "TOPIC"
        },
        {
          key: "TOTAL",
          label: "จำนวน",
          formatter: "TOTAL"
        }
      ],
      items: [],
      items_2:[],
      items_3:[],
      total:0,
      total2:0,
      balance:0,
      total_yes:0,
      total_no:0,
      total_notcomplete:0,
      total_all:0,
      total_balance:0,
      i: 0
    };
  },

  methods: {
    getStatistic(thaistudent,year) {
      api
        .getStatisticByType(thaistudent,year)
        .then(res => {
          // console.log("getStatisticByType==",res.data.data)
          this.items = res.data.data;
           for (var i= 0; i < res.data.data.length ; i++){
                this.total_all=this.total_all+res.data.data[i].TOTAL;
                 var status=res.data.data[i].BYTECODE;
            if ((status==10)||(status==21)||(status==22)||(status==23)||(status==24)||(status==30)||(status==40)) {
                this.total_yes=this.total_yes+res.data.data[i].TOTAL;
            }
            if ((status==50)||(status==60)){
              this.total_no=this.total_no+res.data.data[i].TOTAL;
            }
            // if( (status==0)|| (status==70) || (status==80) ){ //ไม่จบกระบวนการ
            //   this.total_notcomplete=this.total_no+res.data.data[i].TOTAL;
            // }
            //    if (status==80)
            // {
            //   this.total_balance=this.total_balance+res.data.data[i].TOTAL; // ตอนปิดระบบ
            // }
          }
          // this.total_balance=32-(this.total_all); //ตอนเปิดระบบ


        })
        .catch(err => {
          console.log("getStatistic", err.toString());
        });
    },
    getStatisticCountry() {
      api
        .getStatisticCountry()
        .then(res => {
          // console.log("Country==",res)
          this.items_2 = res.data.data;
          for (var i= 0; i < res.data.data.length ; i++){
            this.total2=this.total2+res.data.data[i].TOTAL;


          }
          // console.log("total2==",this.total2)
            this.balance=this.total2-this.total;
        })
        .catch(err => {
          console.log("getStatisticCountry", err.toString());
        });
    }
  },
  mounted() {},
  created() {
    this.getStatistic(0,2566);
    this.getStatisticCountry();

    api.onSetHeader();
  }
};
</script>
<style>
</style>
